
import PropTypes from 'prop-types'
import React from 'react'
import './Animation.css'

const Animation = props => (
  <div className='Animation' type={props.type}>
    {props.children}
  </div>
)

Animation.propTypes = {
  children: PropTypes.element.isRequired,
  type: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]).isRequired
}

Animation.displayName = 'Animation'

export default Animation



// WEBPACK FOOTER //
// ./ui/Animation.js